import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vessel-schedules',
  templateUrl: './vessel-schedules.component.html',
  styleUrls: ['./vessel-schedules.component.scss']
})
export class VesselSchedulesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
